// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientListSyllabaryColumnItem_container__QaIaH"};